var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/mypage.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-34d8839e!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/mypage.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MyPage.vue
// module id = 673
// module chunks = 1